const createPagingRange = (currentPage, totalPageNumber, offset = 2, separator = "...") => {
  const currentPageNumber = currentPage || 1;
  const offsetNumber = currentPageNumber <= offset || currentPageNumber > totalPageNumber - offset ? offset : offset - 1;
  const numbersList = [];
  const numbersListWithDots = [];
  if (totalPageNumber <= 1 || totalPageNumber === void 0) return [1];
  numbersList.push(1);
  for (let i = currentPageNumber - offsetNumber; i <= currentPageNumber + offsetNumber; i++) {
    if (i < totalPageNumber && i > 1) {
      numbersList.push(i);
    }
  }
  numbersList.push(totalPageNumber);
  numbersList.reduce((acc, curr) => {
    if (acc === 1) {
      numbersListWithDots.push(acc);
    }
    if (curr - acc !== 1) {
      numbersListWithDots.push(separator);
    }
    numbersListWithDots.push(curr);
    return curr;
  });
  return numbersListWithDots;
};
export {
  createPagingRange
};
